// Mock data for Grupo Santana Home Services

export const services = [
  {
    id: 1,
    title: "Vacation Rental Cleaning",
    description: "Professional turnover cleaning for Airbnb and short-term rentals. We ensure your property is guest-ready with spotless results every time.",
    icon: "Home",
    accent: "blue"
  },
  {
    id: 2,
    title: "Residential Cleaning",
    description: "Regular house cleaning services tailored to your schedule. Keep your home fresh, clean, and welcoming for your family.",
    icon: "Sparkles",
    accent: "green"
  },
  {
    id: 3,
    title: "Deep Cleaning",
    description: "Thorough top-to-bottom cleaning that reaches every corner. Perfect for seasonal refreshes or when you need extra attention to detail.",
    icon: "Search",
    accent: "gold"
  },
  {
    id: 4,
    title: "Move-In / Move-Out Cleaning",
    description: "Make transitions smooth with our comprehensive move cleaning. Leave your old place spotless or start fresh in your new home.",
    icon: "Truck",
    accent: "blue"
  },
  {
    id: 5,
    title: "Post-Construction Cleaning",
    description: "Remove dust, debris, and construction residue. We prepare your newly renovated space for comfortable living.",
    icon: "Hammer",
    accent: "green"
  },
  {
    id: 6,
    title: "Emergency Cleaning",
    description: "Urgent cleaning when you need it most. Fast response for unexpected situations with reliable, last-minute availability.",
    icon: "Zap",
    accent: "gold"
  },
  {
    id: 7,
    title: "Garage Organization",
    description: "Transform cluttered spaces into organized, functional areas. Professional organization for garages, closets, and storage spaces.",
    icon: "LayoutGrid",
    accent: "blue"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "La Jolla",
    rating: 5,
    text: "Karely and her team are absolutely amazing! They've been cleaning our vacation rental for over a year now, and our guests always comment on how spotless everything is. Highly recommend!",
    service: "Vacation Rental Cleaning"
  },
  {
    id: 2,
    name: "Michael Thompson",
    location: "Pacific Beach",
    rating: 5,
    text: "The deep cleaning service exceeded all expectations. They paid attention to every detail - even areas I didn't think about. My home has never looked better!",
    service: "Deep Cleaning"
  },
  {
    id: 3,
    name: "Jennifer Garcia",
    location: "Carmel Valley",
    rating: 5,
    text: "I called for an emergency cleaning before a family visit, and they came the same day! Professional, efficient, and my house looked incredible. Thank you so much!",
    service: "Emergency Cleaning"
  },
  {
    id: 4,
    name: "David Wilson",
    location: "Del Mar",
    rating: 5,
    text: "After our renovation, the post-construction mess was overwhelming. Grupo Santana made it spotless in just one day. Worth every penny!",
    service: "Post-Construction Cleaning"
  },
  {
    id: 5,
    name: "Amanda Roberts",
    location: "Encinitas",
    rating: 5,
    text: "The garage organization service transformed our cluttered space into something functional and beautiful. We can finally park our cars inside!",
    service: "Garage Organization"
  }
];

export const serviceAreas = [
  { name: "Imperial Beach", important: false },
  { name: "Coronado", important: true },
  { name: "Ocean Beach", important: false },
  { name: "Point Loma / Sunset Cliffs", important: true },
  { name: "Mission Beach", important: false },
  { name: "Pacific Beach", important: true },
  { name: "La Jolla", important: true },
  { name: "Del Mar", important: true },
  { name: "Solana Beach", important: false },
  { name: "Encinitas", important: true }
];

export const ownerInfo = {
  name: "Karely Sánchez",
  title: "Owner & Founder",
  bio: "With over 8 years of experience in professional cleaning and home organization, I founded Grupo Santana Home Services with a simple mission: to provide exceptional cleaning services with a personal touch. I believe every home deserves the same care and attention to detail that I would give my own. My team and I are committed to exceeding your expectations, one spotless space at a time.",
  phone: "(619) 248-6384"
};

export const contactInfo = {
  phone: "(619) 248-6384",
  email: "info@gruposantanahome.com",
  hours: "Monday - Sunday: 7:00 AM - 7:00 PM",
  emergencyHours: "Emergency services available 24/7"
};

export const features = [
  {
    id: 1,
    title: "Reliable & Responsible",
    description: "We show up on time, every time, with professional service you can count on."
  },
  {
    id: 2,
    title: "Attention to Detail",
    description: "We don't just clean - we perfect every corner and surface of your space."
  },
  {
    id: 3,
    title: "Flexible Scheduling",
    description: "Extended hours and last-minute availability to fit your busy lifestyle."
  },
  {
    id: 4,
    title: "Personalized Service",
    description: "Constant communication and care tailored to your specific needs."
  }
];

export const portfolioImages = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/slnpr2ke_WhatsApp%20Image%202026-01-12%20at%201.38.42%20AM.jpeg",
    category: "kitchen",
    title: "Modern Kitchen"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/p52d6qv1_WhatsApp%20Image%202026-01-12%20at%201.39.01%20AM.jpeg",
    category: "bathroom",
    title: "Luxury Bathroom"
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/vghsg9iq_WhatsApp%20Image%202026-01-12%20at%201.39.17%20AM.jpeg",
    category: "bathroom",
    title: "Marble Bathroom"
  },
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/n3vm349o_WhatsApp%20Image%202026-01-12%20at%201.42.22%20AM.jpeg",
    category: "kitchen",
    title: "Spotless Stovetop"
  },
  {
    id: 5,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/1nww6zt9_WhatsApp%20Image%202026-01-12%20at%201.42.31%20AM.jpeg",
    category: "kitchen",
    title: "Stainless Steel Sink"
  },
  {
    id: 6,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/5kana2ld_WhatsApp%20Image%202026-01-12%20at%201.42.45%20AM.jpeg",
    category: "bathroom",
    title: "Marble Bathtub"
  },
  {
    id: 7,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/kw340aoj_WhatsApp%20Image%202026-01-12%20at%201.43.01%20AM.jpeg",
    category: "kitchen",
    title: "Kitchen Island"
  },
  {
    id: 8,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/jq3j6pgl_WhatsApp%20Image%202026-01-12%20at%201.43.15%20AM.jpeg",
    category: "kitchen",
    title: "Kitchen Sink Area"
  },
  {
    id: 9,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/205he171_WhatsApp%20Image%202026-01-12%20at%201.43.24%20AM.jpeg",
    category: "living",
    title: "Polished Floors"
  },
  {
    id: 10,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/jtfqphfv_WhatsApp%20Image%202026-01-12%20at%201.44.37%20AM.jpeg",
    category: "living",
    title: "Coastal Living Room"
  },
  {
    id: 11,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/rk9ctu87_WhatsApp%20Image%202026-01-12%20at%201.46.25%20AM.jpeg",
    category: "bedroom",
    title: "Nautical Bedroom"
  },
  {
    id: 12,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/v95ggyok_WhatsApp%20Image%202026-01-12%20at%201.47.31%20AM.jpeg",
    category: "bedroom",
    title: "Fresh White Linens"
  },
  {
    id: 13,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/szfrc293_WhatsApp%20Image%202026-01-12%20at%201.48.05%20AM.jpeg",
    category: "bedroom",
    title: "Beach Style Suite"
  },
  {
    id: 14,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/ng024cd1_WhatsApp%20Image%202026-01-12%20at%201.49.49%20AM.jpeg",
    category: "bedroom",
    title: "Modern Comfort"
  },
  {
    id: 15,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/4ozyh00s_WhatsApp%20Image%202026-01-12%20at%201.50.10%20AM.jpeg",
    category: "bathroom",
    title: "Luxury Teal Bathroom"
  },
  {
    id: 16,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/i5bihhz6_WhatsApp%20Image%202026-01-12%20at%201.50.53%20AM.jpeg",
    category: "bathroom",
    title: "Marble & Gold Finishes"
  },
  {
    id: 17,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/es2qgfkd_WhatsApp%20Image%202026-01-12%20at%201.52.08%20AM.jpeg",
    category: "bedroom",
    title: "Elegant Beige Suite"
  },
  {
    id: 18,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/3jyzdvpl_WhatsApp%20Image%202026-01-12%20at%201.53.16%20AM.jpeg",
    category: "bathroom",
    title: "Modern Double Vanity"
  },
  {
    id: 19,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/u8rpugto_WhatsApp%20Image%202026-01-12%20at%201.55.49%20AM.jpeg",
    category: "details",
    title: "Coffee Station"
  },
  {
    id: 20,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/4skaljd4_WhatsApp%20Image%202026-01-12%20at%201.57.10%20AM.jpeg",
    category: "bedroom",
    title: "Tropical Mural Room"
  },
  {
    id: 21,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/u2ac2i16_WhatsApp%20Image%202026-01-12%20at%201.58.31%20AM.jpeg",
    category: "kitchen",
    title: "Coastal Kitchen"
  },
  {
    id: 22,
    src: "https://customer-assets.emergentagent.com/job_santana-home-sd/artifacts/tbx2nil1_WhatsApp%20Image%202026-01-12%20at%201.59.26%20AM.jpeg",
    category: "kitchen",
    title: "Quartz Countertop"
  }
];

export const portfolioCategories = [
  { id: "all", label: "All Projects" },
  { id: "kitchen", label: "Kitchens" },
  { id: "bathroom", label: "Bathrooms" },
  { id: "bedroom", label: "Bedrooms" },
  { id: "living", label: "Living Areas" },
  { id: "details", label: "Details" }
];
